import { KeyValuePair } from '../../../core/type'

export const watchDials = [
  'A',
  'A/S',
  'A/ST',
  'AARB',
  'AEAB',
  'AR',
  'AR/ST',
  'AR/STK',
  'ARA',
  'ARA/STK',
  'ARAB',
  'ARAB/DATE',
  'ARAB/DIGIT',
  'ARAB/STK',
  'ARABIC',
  'ARABIC/DAT',
  'ARAV=B',
  'ARB',
  'ARB/DA/24H',
  'ARB/STK',
  'B',
  'BLACK',
  'BLUE',
  'BO',
  'CHRONO',
  'COIN',
  'D',
  'DA',
  'DI',
  'DI DOT',
  'DIA',
  'DIA DOT',
  'DIA DOT/BZ',
  'DIA DOTS',
  'DIGITAL',
  'DO',
  'DOT',
  'DOT`',
  'DOTS',
  'DPT',
  'DT',
  'DTK',
  'FLAG',
  'GLD MRKERS',
  'GOLD DOT',
  'GOLD ROMAN',
  'INGOT',
  'LINES',
  'MARKER',
  'MOP',
  'MU',
  'MUS',
  'MUSEUM',
  'R/ST',
  'rB/DATE',
  'RO',
  'RO/STK',
  'ROAMN/MOON',
  'ROM',
  'ROMAN',
  'ROMAN BEZL',
  'ROMAN/DATE',
  'ROMAN/STIC',
  'ROMAN/STIK',
  'ROMAN/STK',
  'S',
  'S/A',
  'S/AR',
  'SAIL FLAG',
  'SIILV',
  'SK/AR',
  'SKT',
  'SRK',
  'SST',
  'ST',
  'ST/A',
  'ST/AR',
  'ST/R',
  'ST/RO',
  'STICK',
  'STIK',
  'stj',
  'STJ',
  'STK',
  'STK/AR',
  'STK/ARAB',
  'STK/DOT',
  'STK/MUS',
  'stk/rab',
  'STK/RO',
  'STL',
  'TK',
  'WH',
  'WH/BLU',
]

export const itemStoneNames = [
  'DIAMOND',
  'AMETHYST',
  'AQUA',
  'BK TAHITIAN PEARL',
  'BL TOPAZ',
  'BLANK',
  'CAMEO',
  'CHALCEDONY, DYED BL',
  'CITRINE',
  'DYED BLACK PEARL',
  'EMERALD',
  'GARNET',
  'IOLITE',
  'JADE',
  'LAPIS',
  'MABE PEARL',
  'MALACHITE',
  'ONYX',
  'OPAL',
  'PEARL',
  'PERIDOT',
  'ROSE QUARTZ',
  'RUBY',
  'SAPPHIRE',
  'SYN EMERALD',
  'SYN SAPPHIRE',
  'SYN STAR RUBY',
  'SYN STAR SAPPHIRE',
  'TANZANITE',
  'TIGER EYE',
  'TOURMALINE,GREEN',
  'TOURMALINE,PINK',
  'TURQUOISE',
  'WH TAHITIAN PEARL',
  'ZIRCON,BLUE',
  'ZIRCON,WHITE',
  'LAB DIAMOND',
  'ALEXANDRITE',
  'PINK SAPPHIRE',
]

export const colors: KeyValuePair[] = [
  ...[
    'D', 'E', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'W', 'X', 'Y', 'Z',
    'D-E',
    'E-F',
    'F-G',
    'G-H',
    'H-I',
    'I-J',
    'J-K',
    'K-L',
    'L-M',
    'M-N',
    'N-O',
    'O-P',
    'R-S',
    'S-T',
    'W-X',
    'Y-Z',
  ]
    .map(ch => ({
      key: ch,
      value: ch
    })),
  {key: 'F', value: 'F'},
  {key: 'Vivid (V)', value: 'V'},
  {key: 'Fancy Light (FL)', value: 'FL'},
  {key: 'Fancy Deep (FD)', value: 'FD'},
  {key: 'Fancy Yellow (FY)', value: 'FY'},
  {key: 'Fancy Light Yellow (FLY)', value: 'FLY'},
  {key: 'Fancy Vivid Yellow (FVY)', value: 'FVY'},
  {key: 'Fancy Vivid (FV)', value: 'FV'}
]
  .sort(({key: a}, {key: b}) => {
    const aFancy = a.startsWith('Fancy')
    const bFancy = b.startsWith('Fancy')
    // Keep the Fancy group in declaration order (sort is stable), so its
    // ordering stays explicit instead of engine-dependent.
    if (aFancy && bFancy)
      return 0
    if (aFancy)
      return 1
    if (bFancy)
      return -1
    return a.localeCompare(b)
  })

export const clarity: KeyValuePair[] = [
  ...[
    'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3', 'I1', 'I2', 'I3',
    'VVS-VS',
    'VS1-VS2',
    'VS2-SI1',
    'SI1-SI2',
    'SI2-SI3',
    'SI3-I1',
    'I1-I2',
    'I2-I3',
  ]
    .map(ch => ({
      key: ch,
      value: ch
    })),
  {key: 'Internally Flawless (IF)', value: 'IF'},
]
  .sort(({key: a}, {key: b}) => {
    if (a.startsWith('Internally Flawless'))
      return 1
    if (b.startsWith('Internally Flawless'))
      return -1
    return a.localeCompare(b)
  })